import { useRouter } from 'vue-router';
import {useToast} from "vue-toast-notification";

// Les requêtes en cours sont interrompues quand on quitte ou recharge la page : ce n'est pas une erreur
let isPageLeaving = false;
window.addEventListener('beforeunload', () => {
    isPageLeaving = true;
});

export function useHttpErrorsHandler() {

    const router = useRouter();
    const $toast = useToast();

    function httpErrorsHandler(errors) {

        if (!errors.response) {
            console.error(errors);

            // Requête annulée, ou interrompue parce que l'utilisateur quitte ou recharge la page,
            // ou lancée pendant que l'onglet est en arrière-plan (actualisation automatique) : rien à signaler
            if (errors.code === 'ERR_CANCELED' || isPageLeaving || document.visibilityState === 'hidden') {
                return;
            }

            // Requête partie mais restée sans réponse : coupure réseau, serveur injoignable
            const isNetworkError = errors.isAxiosError && errors.request
            const message = !navigator.onLine
                ? 'Vous êtes hors ligne : vérifiez votre connexion internet'
                : isNetworkError
                    ? 'Le serveur ne répond pas, réessayez dans un instant'
                    : 'Une erreur inattendue est survenue'

            $toast.error(message, {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            });
            return;
        }

        const status = errors.response.status;
        const message = errors.response.data && errors.response.data.message
            ? errors.response.data.message
            : 'Erreur inconnue';

        switch (status) {
            case 401:
                $toast.error('Vous êtes déconnecté', {
                    position: 'top',
                    duration: 5000,
                    dismissible: true,
                    pauseOnHover: true,
                });
                window.location.replace('/login');
                break;
            case 403:
                $toast.error('Vous n\'êtes pas autorisé à effectuer cette action', {
                    position: 'top',
                    duration: 5000,
                    dismissible: true,
                    pauseOnHover: true,
                });
                router.replace({ path: '/unauthorized' })
                break;
            case 404:
                $toast.error('Ressource non trouvée', {
                    position: 'top',
                    duration: 5000,
                    dismissible: true,
                    pauseOnHover: true,
                });
                router.replace({ path: '/not-found' })
                break;
            default:
                $toast.error(message, {
                    position: 'top',
                    duration: 5000,
                    dismissible: true,
                    pauseOnHover: true,
                });
        }
    }

    return {
        httpErrorsHandler,
    };
}
